// External
import React, { Component } from "react";
import { connect } from "react-redux";
import {
  removeInfoFeedMessage,
  setDashboardParams,
  setInfoFeedMessage,
  setSessionVar,
} from "../../store/actions";
import { cloneDeep, debounce, filter, get } from "lodash";
import Moment from "moment";

//Maps Stuff
//I take control of the OL Map in a few functions here to simplify the process.
import Feature from "ol/Feature";
import VectorSource from "ol/source/Vector";
import { Polygon } from "ol/geom";
import { convexHull } from "../../utils/geom";
import convex from "@turf/convex";
import transformScale from "@turf/transform-scale";

// Internal
import BaseMap, { getDefaultBounds } from "../maps/BaseMap";
import FloatHeader from "../theme/headers/FloatHeader";
import { defaultMapState } from "./CreateSite";
import InfoTileFeed from "../subscreens/InfoFeed";
import FilterDisplay from "../subscreens/FilterDisplay";
import {
  filterAndSortItems,
  handleFilterDeletion,
  handleSearchChange,
} from "../../utils/FilterDisplayUtils";
import TurfNoteModal from "../theme/modals/TurfNoteModal";
import TurfFilterModal from "../theme/modals/TurfFilterModal";
import DistrictNoteModal from "../theme/modals/DistrictNoteModal";
import DistrictFilterModal from "../theme/modals/DistrictFilterModal";

import Input from "../theme/forms/Input";
import Tabs from "../theme/menus/Tabs";
import BasicButton from "../theme/buttons/BasicButton";
import FeedbackTile from "../theme/modals/FeedbackTile";
import { coloredPolygonStyle } from "../maps/olStyles";
import DistrictTurfListItem from "../maps/listItems/DistrictTurfListItem";
import api from "../../store/api/api";
import BaseModal from "../theme/modals/BaseModal";
import BaseForm from "../theme/forms/BaseForm";
import * as formFields from "../../utils/forms/formFields";
import * as doorCalls from "../../store/api/calls/doors";
import {
  defaultPolyStyle,
  groupedRelativePointStyle,
  relativeSizePointStyle,
} from "../maps/BaseMapStyles";
import { pullSiteNoteCategories } from "../../store/api/calls";
import { withRouter } from "../../utils/withRouter";

const US_DEFAULT_MAP_VIEW = {
  longitude: defaultMapState.center.lng,
  latitude: defaultMapState.center.lat,
  zoom: defaultMapState.zoom,
};

class TurfCutter extends Component {
  constructor(props) {
    super(props);

    this.state = {
      ...defaultMapState,
      districtFeatures: [],
      turfFeatures: [],
      lassoedFeatures: [],
      loadedFeatures: [],
      features: [],

      //district vars
      selectedDistricts: [],
      districtType: "precinct_name",
      districtSidebarTab: "available",
      districtFilterText: null,

      //turf vars
      turfs: [],
      editingTurf: null,
      turfEditModalOpen: false,
      releaseDoorsModalOpen: false,

      //status vars
      pageError: false,
      isLoading: false,
      errMsg: "Whoops! There's been a server error.",
      sideBarClosed: false,
      mapMode: "district", //can also be "turf"
      zoomLevel: 0,

      hoverInfoBoxIsActive: false,
      hoverInfoBoxInfo: [],

      doorcanvasspass: null,

      turfFilters: {
        id: "turfs",
        keyword: "",
        keywordPersist: "",
        noteTags: [],
        sortBy: "name",
        sortDsc: false,
        searchFields: ["name", "noteString", "code_name"],
        sortFields: [
          {
            display: "Name",
            value: "name",
          },
          {
            display: "Doors",
            value: "household_count",
          },
          {
            display: "Targets",
            value: "target_count",
          },
        ],
      },

      districtFilters: {
        id: "districts",
        keyword: "",
        keywordPersist: "",
        noteTags: [],
        sortBy: "name",
        sortDsc: false,
        searchFields: ["name", "noteString"],
        sortFields: [
          {
            display: "Name",
            value: "name",
          },
          {
            display: "Doors",
            value: "household_count",
          },
          {
            display: "Turfs",
            value: "turf_count",
          },
          {
            display: "% Cut",
            value: "cut",
          },
          {
            display: "Walkable",
            value: "walkable_cut",
          },
          {
            display: "Unwalkable",
            value: "unwalkable_cut",
          },
          {
            display: "Attempted",
            value: "attempted",
          },
        ],
      },
      hiddenTargets: [],
      hiddenTurfs: [],
      selectedPointsPoly: null,
      cutTurfPolys: [],
      visibleDistrictIds: null,
    };

    this.olMap = React.createRef();

    this.polygonSelectLayer = null;
    this.turfsLayer = null;

    this.modify = null;

    // corresponds to width var set in maps.scss
    this.sideBarColWidth = 280;

    // d3 scheme paired
    this.routeColors = [
      "#a6cee3",
      "#1f78b4",
      "#b2df8a",
      "#33a02c",
      "#fb9a99",
      "#e31a1c",
      "#c6158a",
      "#ff7f00",
      "#cab2d6",
      "#40399a",
      "#ecb012",
    ];

    this.unwalkableRouteColor = "#b14c0a";

    // this is min/max value of the household count to build the d3 scales
    this.districtScaleExtent = [];
    this.LABEL_ZOOM_THRESHOLD = 13;
    this.filterTimeout = null;
  }

  componentDidMount() {
    this.getCutableFields();
    doorCalls.getTurfCodes();
    pullSiteNoteCategories();
  }

  componentWillUnmount() {
    clearTimeout(this.lassoHandle);
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.state.turfs !== prevState.turfs) {
      this.setState({ cutTurfPolys: this.buildCutTurfPolys() });
    }
  }

  buildCutTurfPolys = () => {
    return this.state.turfs.map((turf) => {
      const turfFeatures = turf.targets.map((target) => {
        return this.state.turfFeatures.find((t) => t.id === target);
      });

      let encodedPoints = this.encodePoints(turfFeatures);

      let poly = null;

      if (encodedPoints.features.length > 2) {
        poly = convex(encodedPoints);
      }

      if (poly) {
        poly = transformScale(poly, 1.1);
      }
      console.log(poly);

      return (
        !!poly && {
          ...poly,
          properties: {
            polyColor: this.getTurfColor(turf, turf.id),
            data: turf,
          },
          id: turf.id,
        }
      );
    });
  };

  handleTurfsOnFilter = () => {
    let visibleTurfs = filterAndSortItems(
      this.state.turfs,
      this.state.turfFilters
    );

    let visibleTargets = visibleTurfs.map((t) => t.targets).flat();

    let hiddenTurfs = this.state.turfs.filter(
      (turf) => !visibleTurfs.find((vTurf) => vTurf.id === turf.id)
    );

    let hiddenTargets = hiddenTurfs.map((t) => t.targets).flat();
    // need for onmouseenter disabling to work
    this.setState({
      hiddenTargets,
      hiddenTurfs,
    });
  };

  handleDistrictsOnFilter = () => {
    let visibleDistricts = filterAndSortItems(
      this.state.districtFeatures,
      this.state.districtFilters
    );
    let visibleIds = visibleDistricts.map((d) => d.id);
    let hiddenIds = this.state.districtFeatures
      .filter((d) => !visibleIds.includes(d.id))
      .map((d) => d.id);
  };

  handleDistrictFilterModalClose = (filters) => {
    this.setState(
      {
        filterModalOpen: false,
        districtFilters: { ...this.state.districtFilters, ...filters },
      },
      () => this.handleDistrictsOnFilter()
    );
  };

  handleTurfFilterModalClose = (filters) => {
    this.setState(
      {
        filterModalOpen: false,
        turfFilters: { ...this.state.turfFilters, ...filters },
      },
      () => this.handleTurfsOnFilter()
    );
  };

  _getDistrictTypeDisplay = () => {
    const field = (this.state.cutableFields || []).find(
      (d) => d.value === this.state.districtType
    );
    return field?.display || this.state.districtType;
  };

  resetMapToDefaultView = () => {
    const map =
      this.mapRef?.current?.getMap?.() || this.mapRef?.current;
    if (map?.jumpTo) {
      map.jumpTo({
        center: [US_DEFAULT_MAP_VIEW.longitude, US_DEFAULT_MAP_VIEW.latitude],
        zoom: US_DEFAULT_MAP_VIEW.zoom,
      });
    } else if (map?.panTo) {
      map.panTo(
        [US_DEFAULT_MAP_VIEW.longitude, US_DEFAULT_MAP_VIEW.latitude],
        { animate: false }
      );
      map.zoomTo?.(US_DEFAULT_MAP_VIEW.zoom, { animate: false });
    }
  };

  handleMountOrDistrictTypeChange = () => {
    const {params} = this.props;
    const doorcanvass_pass_id = params.doorcanvass_pass_id || 0;

    this.setState({
      isLoading: true,
      doorcanvasspass: doorcanvass_pass_id,
      error: false,
      pageError: false,
    });
    return api
      .get(`/districtview/${doorcanvass_pass_id}/`, {
        type: this.state.districtType,
      })
      .then((res) => {
        const districts = res.data || [];

        if (!districts.length) {
          this.districtScaleExtent = [0, 1];
          this.setState(
            {
              districtFeatures: [],
              loadedFeatures: [],
              isLoading: false,
            },
            () => {
              this.resetMapToDefaultView();
              this.setError(
                `No districts found for "${this._getDistrictTypeDisplay()}". Try a different district type.`
              );
            }
          );
          return;
        }

        //set scale extent for display
        let household_counts = districts.map((d) => d.household_count);
        this.districtScaleExtent = [
          Math.min(...household_counts),
          Math.max(...household_counts),
        ];

        let districtFeatures = districts.map((d) => ({
          ...d,
          name: d.name + "", // force string
          onClick: (e) => {
            this.state.selectedDistricts.find((_d) => _d.id === d.id)
              ? this.handleSelectedDistrictRemoval(d)
              : this.handleAvailDistrictDoubleClick(d);
          },
        }));
        this.setState({
          districtFeatures,
          loadedFeatures: cloneDeep(districtFeatures),
          isLoading: false,
        });
      })
      .catch((err) => {
        this.setState({ isLoading: false, pageError: true });
      });
  };

  getCutableFields = () => {
    let matched_dcp = this.props.doorCanvassPasses.find(
      (d) => d.id === +this.props.params.doorcanvass_pass_id
    );

    const parseCutableFields = () => {
      let cutableFields = get(
        matched_dcp,
        "canvass.cut_config.cutable_fields",
        []
      );

      if (!Array.isArray(cutableFields) || !cutableFields.length) {
        cutableFields = [
          { type: "precinct_name", display: "Precinct" },
          { type: "county_name", display: "County" },
          { type: "city", display: "City" },
          { type: "zip5", display: "Zipcode" },
        ];
      }

      cutableFields = cutableFields.map((d) => ({
        ...d,
        value: d.type,
      }));

      if (cutableFields.length) {
        this.setState({ cutableFields }, () => {
          this._handleChangeDistrictType(this.state.cutableFields[0].value);
        });
      } else {
        this.setError("No cutable fields found");
      }
    };

    if (matched_dcp) {
      //match found
      parseCutableFields();
    } else {
      doorCalls.pullCampaignDoorCanvassPasses().then((data) => {
        matched_dcp = this.props.doorCanvassPasses.find(
          (d) => d.id === +this.props.params.doorcanvass_pass_id
        );
        parseCutableFields();
      });
    }
  };

  _startCutTurf = () => {
    const {params} = this.props;
    const doorcanvass_pass_id = params.doorcanvass_pass_id || 0;


    this.setState({ isLoading: true });
    api
      .post(`/districthouseholds/${doorcanvass_pass_id}/`, {
        districts: [...this.state.selectedDistricts.map((d) => d.name)],
        notes: 1,
        type: this.state.districtType,
      })
      .then((res) => {
        let features = res.data.households.map((d) => ({
          ...d,
          lon: +d.longitude,
          lat: +d.latitude,
        }));

        features = features.sort((a, b) => a.cluster_count < b.cluster_count);

        // we need to just kill lassoed so we can keep selected features for the districts
        // list while cutting
        this.setState({
          mapMode: "turf",
          turfFeatures: features,
          lassoedFeatures: [],
        });
        this.props.removeInfoFeedMessage("count_selected_districts");

        return res.data.turfs;
      })
      //handle adding and styling trufs
      .then((turfs) => {
        turfs = turfs.sort((a, b) => a.id < b.id);

        let source = new VectorSource({
          features: [],
        });

        turfs
          .map((turf) => this.setTurfCodeDataOnTurfObj(turf))
          .forEach((turf, idx) => {
            let color = this.getTurfColor(turf, turf.id);
            let opacity = turf.is_walkable === false ? 0.3 : 1;
            let strokeWidth = 3;
            let feature = this.buildConvexHullPoly({
              id: turf.id,
              name: turf.name,
              idsInPoly: turf.targets,
            });

            feature.setId(turf.id);

            feature.setStyle(coloredPolygonStyle(color, strokeWidth, opacity));
            source.addFeature(feature);
          });

        this.setState({ isLoading: false, turfs });
      })
      .then(() => {
        return getDefaultBounds([
          { data: this.encodePoints(this.state.turfFeatures) },
        ]);
      })
      .then((bounds) => {
        this.mapRef.current.panTo([bounds.longitude, bounds.latitude], {
          animate: false,
        });
        this.mapRef.current.zoomTo(bounds.zoom, { animate: false });
      })
      .catch((err) => {
        console.error("[POST ERROR]", err);
        this.setState({ isLoading: false });
      });
  };

  clearLassos = (styleConfig = {}) => {
    //use style config to edit style off default after removal
    this.setState({ lassoedFeatures: [], selectedPointsPoly: null }, () =>
      this.props.removeInfoFeedMessage("district-doors-count")
    );
  };

  _addLassoedDistrictsToSelected = () => {
    //first remove dupes
    let newDistrictList = [
      ...this.state.selectedDistricts,
      ...this.state.lassoedFeatures,
    ].filter((d, i, a) => a.findIndex((_d) => _d.id === d.id) === i);
    this.setState(
      {
        lassoedFeatures: [],
        selectedDistricts: newDistrictList,
        districtSidebarTab: "selected",
      },
      this.clearLassos({ fill: "#fdbf6f", save: true })
    );
  };

  _clearSelectedDistricts = (ids) => {
    ids = ids || this.state.selectedDistricts.map((d) => d.id);
    let selectedDistricts = [
      ...this.state.selectedDistricts.filter((d) => d.id),
    ];
    this.setState({ selectedDistricts: [] });
  };

  handleDblClick = () => {
    if (this.state.editingTurf) {
      this.cancelTurfUpdate();
      this.clearLassos({ clear: true });
      return;
    }

    this.clearLassos({ clear: true });
    if (this.polygonSelectLayer) {
      this.olMap.current.map.removeLayer(this.polygonSelectLayer);
      this.polygonLayer = null;
    }
  };

  handleMapZoom = (zoomLevel) => {
    const stateZoom = +this.state.zoomLevel.toString(); //clone to prevent update on state change
    this.setState({ zoomLevel });

    if (
      stateZoom < this.LABEL_ZOOM_THRESHOLD &&
      zoomLevel >= this.LABEL_ZOOM_THRESHOLD
    ) {
      this.olMap.current.featuresLayer.changed();
    }

    if (
      stateZoom >= this.LABEL_ZOOM_THRESHOLD &&
      zoomLevel < this.LABEL_ZOOM_THRESHOLD
    ) {
      this.olMap.current.featuresLayer.changed();
    }
  };

  onMarkerHover(point) {
    if (!point) {
      this.setState({ hoverInfoBoxIsActive: false, hoverInfoBoxInfo: [] });
    } else if (point.name && this.state.mapMode === "turf") {
      let turf = this.state.turfs.find((t) => t.id === point.get("id"));
      if (!turf) {
        console.warn("No Turf Found for color update");
        return;
      }

      let visibleTurf = !this.state.hiddenTurfs.find(
        (t) => point.get("id") === t.id
      );

      let turfColor = visibleTurf ? this.getTurfColor(turf, turf.id) : "#000";
    } else {
      let id = point.id;
      let feature = this.state.districtFeatures.find((d) => d.id === id);

      let visibleTarget = !this.state.hiddenTargets.includes(id);

      if (feature && this.state.mapMode === "turf" && visibleTarget) {
        this.setState({
          hoverInfoBoxIsActive: true,
          hoverInfoBoxInfo: [
            feature.street_address_1,
            feature.city_state_zip,
            `${feature.cluster_count} households`,
            `${this.state.districtFeatures.reduce(
              (r, d) =>
                d.cluster_hash === feature.cluster_hash
                  ? r + d.target_count
                  : r,
              0
            )} targets`,
          ],
        });
      } else if (!visibleTarget && this.state.mapMode === "turf") {
      }
    }
  }

  _handleChangeDistrictType = (districtType) => {
    this.clearLassos();
    this.setState(
      {
        districtType,
        selectedDistricts: [],
        lassoedFeatures: [],
      },
      () => this.handleMountOrDistrictTypeChange()
    );
  };

  //turf functions
  createTurf = (inputs) => {
    this.setLoading();
    return api
      .post("/turfs/", {
        ...inputs,
        household_count: this.state.lassoedFeatures.length,
        target_count: this.state.lassoedFeatures.reduce(
          (r, d) => r + (d.target_count || 0),
          0
        ),
        doorcanvasspass: this.state.doorcanvasspass,
        targets: this.state.lassoedFeatures.map((d) => d.id),
      })
      .then((res) => {
        this.addTurfToMap(res.data);
        this.setSuccess();
        return res.data;
      })
      .catch((err) => {
        console.error(err);
        this.setError();
      });
  };

  removeTurfFromMap = (turf_id) => {
    this.setState({
      turfs: this.state.turfs.filter((turf) => turf.id !== turf_id),
    });
  };

  deleteTurf = (turf_id) => {
    return api
      .delete(`/turfs/${turf_id}/`)
      .then(() => {
        this.setSuccess();
        let deletionTurf = this.state.turfs.find((d) => d.id === turf_id);
        this.setState({
          turfs: this.state.turfs.filter((d) => d.id !== turf_id),
        });

        this.removeTurfFromMap(turf_id);
      })
      .catch((err) => {
        if (err.response && err.response.status === 409) {
          this.setError(
            "A turf you tried to delete is assigned today or in the future."
          );
        } else {
          this.setError();
        }
      });
  };

  getTurfColor = (turf, idx) => {
    if (!turf) return;

    if (turf.is_walkable === false) return this.unwalkableRouteColor;

    if (!turf.color) {
      let turfIndex =
        idx || this.state.turfs.findIndex((d) => d.id === turf.id);
      turfIndex = turfIndex >= 0 ? turfIndex : 0;
      return this.routeColors[turfIndex % this.routeColors.length];
    } else {
      return turf.color;
    }
  };

  setTurfCodeDataOnTurfObj = (turf) => {
    let turf_code_obj =
      this.props.turfCodes.find((d) => d.id === +turf.code) || {};
    turf.code_name = turf_code_obj.name;
    turf.is_walkable = turf_code_obj.walkable !== false;

    return turf;
  };

  //edit config here is only used when adding the turf back to the map after editing
  addTurfToMap = (turf, editConfig = {}) => {
    let idx = ![null, undefined].includes(editConfig.idx)
      ? editConfig.idx
      : this.state.turfs.length;
    turf = this.setTurfCodeDataOnTurfObj(turf);
    if (!turf.color) {
      turf.color = this.getTurfColor(turf, turf.id); //length will be the index when it's added, so we get the right color
    }
    let new_turfs = [...this.state.turfs];

    if (![null, undefined].includes(editConfig.idx)) {
      new_turfs[editConfig.idx] = { ...new_turfs[editConfig.idx], ...turf };
    } else {
      new_turfs.push(turf);
    }
    this.setState({ turfs: new_turfs });

    // pull the feature and remove the polygonSelectLayer

    this.clearLassos(); // clear the lassoes
    this.polygonSelectLayer = null;
  };

  handleCreateTurfRequest = (households) => {
    this.setState({ turfEditModalOpen: true });
  };

  onCloseTurfEditModal = () => {
    this.setState({ turfEditModalOpen: false });
  };

  handleTurfItemHover = (turf, idx, entering = true) => {
    this.setState({
      hoveredFeatures: entering ? [turf.id] : null,
      hoveredSource: entering ? "convex-hulls" : null,
    });
  };

  makeTurfEditable = (turf) => {
    //pull the polygon out the turfs layer and into the district select layer
    this.removeTurfFromMap(turf.id);
    let targets = [...turf.targets];

    //we have the set of IDS, no map over loadedFeatures to pull the actual object
    //set this component's state.
    //we can't set lassoed features until after the editing turf, because if you do you will clash with
    //the feature that prevents selection of existing turfs (aka, prevents double assignment
    this.setState({ editingTurf: turf }, () => {
      this.setState(
        {
          lassoedFeatures: this.state.turfFeatures
            .filter((d) => targets.includes(d.id))
            .map((t) => {
              return { ...t, source: "turf-points" };
            }),
        },
        () => {
          this.setState({
            selectedPointsPoly:
              this.state.lassoedFeatures.length > 2 &&
              transformScale(
                convex(this.encodePoints(this.state.lassoedFeatures)),
                1.1
              ),
          });
        }
      );
    });
  };

  /*
   * post the actual changes. the post endpoint of /turfs/turf_id/, which is what edits request, accepts two
   * keys in the json dict: targets (an array of ids of targets to add) and remove_targets (an array of ids of targets to remove);
   */
  handleUpdateTurfRequest = () => {
    let { editingTurf: turf } = this.state;

    let lassoedIds = this.state.lassoedFeatures.map((d) => d.id);

    //build the array of ids that have been added to the turf
    let add_targets = lassoedIds.filter((d) => !turf.targets.includes(d));
    //build the array of ids that we need to remove
    let remove_targets = turf.targets.filter((d) => !lassoedIds.includes(d));

    this.setState({ isLoading: true });

    return api
      .post(`/turfs/${turf.id}/`, {
        ...turf,
        household_count: this.state.lassoedFeatures.length,
        targets: add_targets,
        remove_targets,
      })
      .then((res) => {
        let { data } = res;
        let turfs = [...this.state.turfs];
        this.setState({ editingTurf: null }, () => {
          this.addTurfToMap({ ...turf, ...data });
        });
        this.setSuccess();
      })
      .catch(() => {
        this.setError("Looks like we had a problem updating the turf.");
      });
  };

  cancelTurfUpdate = () => {
    let turfs = [...this.state.turfs];
    let editingTurf = { ...this.state.editingTurf };
    let turf_idx = turfs.findIndex((d) => d.id === editingTurf.id);
    this.setState({ editingTurf: null }, () => {
      this.addTurfToMap(editingTurf);
    });
  };

  handleReleaseUnknockedDoorsRequest = () => {
    this.setState({ releaseDoorsModalOpen: true });
  };

  onCloseReleaseDoorsModal = () => {
    this.setState({ releaseDoorsModalOpen: false });
  };

  releaseUnknockedDoors = () => {
    /*
     * 1_ loop over turfs, get targets.
     * 2_ loop over features -- see if it has been attempted
     * 3_ if so, remove from turf. // add the the remove_targets array;
     * 4_ if
     * */

    let calls = [];
    this.state.turfs.forEach((turf) => {
      let attempted_in_turf = turf.targets.filter((d) => {
        const feature = this.state.turfFeatures.find((f) => f.id === d);
        return feature ? feature.attempted : 0;
      });
      if (attempted_in_turf.length > 0) {
        console.log("releasing!!", turf, attempted_in_turf);
        return api
          .post(`/turfs/${turf.id}/`, {
            ...turf,
            household_count: turf.targets.length - attempted_in_turf.length,
            remove_targets: attempted_in_turf,
          })
          .then((res) => {
            let { data } = res;
            let turfs = [...this.state.turfs];
            let turf_idx = turfs.findIndex((d) => d.id === data.id);
            this.setState({ editingTurf: null }, () => {
              this.addTurfToMap(data, { idx: turf_idx });
            });
            this.setSuccess();
          })
          .catch(() => {
            this.setError("Looks like we had a problem updating " + turf.name);
          });
      }
    });
  };

  /*
   * Config keys
   * featureCallback: function to be called in forEachFeature loop, passed feature and index
   * idsInPoly: a list of ids of features in the poly layer
   * id: id of the created polygon
   * name: name of the created polygon
   */

  buildConvexHullPoly = (config) => {
    let targetCoords = [];
    let { idsInPoly, featureCallback } = config;

    // if (targetCoords.length > 2) {
    // targetPoints.push(targetPoints[0]); //last must be same as first to complete the ring;

    const pointRing = convexHull(targetCoords);
    let polygon = new Polygon([pointRing]); //scale up so it doesn't rest directly on the points
    //createEnclaves(polygon, source, idsInPoly); // no all points in the convex hull might have been selected
    polygon.scale(1.03);

    let feature = new Feature({
      geometry: polygon,
      id: config.id,
      name: config.name,
    });

    return feature;
    // }
  };

  filterFeaturesByName() {
    if (!this.state.districtFilterText || this.state.districtFilterText === "")
      return this.state.districtFeatures;

    const predicate = (o) => {
      for (const k in o) {
        const v = o["name"];
        if (typeof v === "Number") continue;
        const coercedValue = String(v);
        if (
          coercedValue
            .trim()
            .toLowerCase()
            .includes(this.state.districtFilterText)
        ) {
          return true;
        }
      }
      return false;
    };

    //check for the presence of this.state.filterText in various fields
    //go through unknown objects and check for presence in values
    return filter(this.state.districtFeatures, predicate);
  }

  handleDistrictFilterChange = (val) => {
    let TIMEOUT_LEN = 800;
    clearTimeout(this.filterTimeout);
    this.setState({ districtFilterText: val });
    if (val.length < 2) {
      if (
        this.state.districtFeatures.length !== this.state.loadedFeatures.length
      ) {
        this.filterTimeout = setTimeout(
          () =>
            this.setState({
              districtFeatures: cloneDeep(this.state.loadedFeatures),
            }),
          TIMEOUT_LEN
        );
      }
    } else {
      this.filterTimeout = setTimeout(
        () => this.setState({ districtFeatures: this.filterFeaturesByName() }),
        TIMEOUT_LEN
      );
    }
  };

  handleAvailDistrictDoubleClick = (district) => {
    let selectedDistricts = [...this.state.selectedDistricts, district];
    this.setState({ selectedDistricts });

    this.props.setInfoFeedMessage({
      id: "district-added-by-click",
      msg: `${this.state.districtType} ${district.name} added to selection`,
      timeOutLength: 10 * 1000,
    });
    this.props.setInfoFeedMessage({
      id: "count_selected_districts",
      msg: selectedDistricts.length + " Total Districts Selected",
      timeoutLength: selectedDistricts.length ? 9999999999 : 3000,
      onClick: selectedDistricts.length
        ? this.handleDeselectAllDistricts
        : null,
      onClickName: "Deselect All",
      cantClose: true,
    });
  };

  handleDeselectAllDoors = () => {
    this.setState({ lassoedFeatures: [] });
    this.props.removeInfoFeedMessage("count_selected_doors");
  };

  handleDeselectAllDistricts = () => {
    this.setState({ selectedDistricts: [] });
    this.props.removeInfoFeedMessage("count_selected_districts");
  };

  handleSelectedDistrictRemoval = (district) => {
    let selectedDistricts = [
      ...this.state.selectedDistricts.filter((d) => d.id !== district.id),
    ];
    this.setState({ selectedDistricts });

    this.props.setInfoFeedMessage({
      id: "count_selected_districts",
      msg: selectedDistricts.length + " Total Districts Selected",
      timeoutLength: selectedDistricts.length ? 9999999999 : 3000,
      onClick: selectedDistricts.length
        ? this.handleDeselectAllDistricts
        : null,
      onClickName: "Deselect All",
      cantClose: true,
    });
  };

  handleDistrictNoteCreateOrDestroy = (newDistricts) => {
    const oldDistricts = [...this.state.districtFeatures];
    const mergedDistricts = oldDistricts.map((district) => {
      const matchingDistrict = newDistricts.find((d) => d.id === district.id);
      return matchingDistrict ? matchingDistrict : district;
    });

    this.props.setDistrictNoteModalDistricts(newDistricts);
    this.setState({
      districtFeatures: mergedDistricts,
    });
  };

  handleTurfNoteCreateOrDestroy = (turf) => {
    let turfs = [...this.state.turfs];
    let turf_idx = turfs.findIndex((d) => d.id === turf.id);
    if (turf_idx > -1) {
      this.props.setTurfNoteModalTurf(turf);
      turfs[turf_idx] = turf;
    }

    this.setState({
      turfs,
    });
  };

  bulkAddDistrictNotes = () => {
    this.props.setDistrictNoteModalDistricts(this.state.selectedDistricts);
  };

  _renderDistrictSelectSideBar() {
    const visibleDistricts = filterAndSortItems(
      this.state.districtFeatures,
      this.state.districtFilters
    ).filter((district) => {
      return this.state.viewState?.visiblePoints
        ? this.state.viewState.visiblePoints.indexOf(district.id) > -1
        : true;
    });

    let tabClickHandler = (selection) => {
      this.setState({ districtSidebarTab: selection });
    };

    let tabs = [
      {
        display: "Available",
        active: this.state.districtSidebarTab === "available",
        onClick: () => tabClickHandler("available"),
      },
      {
        display:
          "Selected " +
          (this.state.selectedDistricts.length > 0
            ? ` (${this.state.selectedDistricts.length})`
            : ""),
        active: this.state.districtSidebarTab === "selected",
        onClick: () => tabClickHandler("selected"),
      },
    ];

    let districtValue =
      this.state.districtFilters.keywordPersist !== ""
        ? { value: this.state.districtFilters.keyword }
        : { test: 1 };

    const debouncedDistrictSearch = debounce((query) => {
      const stateChanges = handleSearchChange(query);
      this.setState(
        {
          ...stateChanges[0],
          districtFilters: {
            ...this.state.districtFilters,
            keyword: stateChanges[1],
          },
        },
        () => this.handleDistrictsOnFilter()
      );
    }, 300);

    return (
      <>
        <div className="side-menu-title" style={{ marginBottom: ".3em" }}>
          <h3 className="primary-text" style={{ textAlign: "center" }}>
            Select Districts
          </h3>
          <Input
            type={"select"}
            title={"District Type"}
            value={this.state.districtType}
            onChange={this._handleChangeDistrictType}
            options={this.state.cutableFields}
          />

          {!!this.state.lassoedFeatures.length && (
            <BasicButton
              disabled={this.state.addRouteValue === ""}
              on_click={this._addLassoedDistrictsToSelected}
              aria_label="Add to Selected"
              label="Add to Selected"
              className="mapButton"
            />
          )}

          {!!this.state.selectedDistricts.length && (
            <>
              <BasicButton
                disabled={
                  this.state.addRouteValue === "" || this.state.isLoading
                }
                on_click={() => this._clearSelectedDistricts()}
                aria_label="Clear Selection"
                label="Clear Selection"
                className="mapButton danger light danger-text"
              />
              <BasicButton
                disabled={
                  this.state.addRouteValue === "" || this.state.isLoading
                }
                on_click={() => this._startCutTurf()}
                label="Cut Turf"
                className="mapButton success light success-text"
              />
              <BasicButton
                on_click={() => this.bulkAddDistrictNotes()}
                label="Bulk add notes"
                className="mapButton success light success-text"
              />
            </>
          )}
        </div>

        {!!this.state.selectedDistricts.length && (
          <div className="agg-metrics">
            <div className="agg-metric">
              <span className="metricKey" tyle={{ fontWeight: "regular" }}>
                Households Selected
              </span>
              <span className="metricValue" style={{ fontWeight: "bold" }}>
                {this.state.selectedDistricts.reduce(
                  (r, d) => +d.household_count + r,
                  0
                )}
              </span>
            </div>
          </div>
        )}

        <div className="side-menu-body">
          <Tabs
            // style={{padding: '0 4rem !important'}}
            tabs={tabs}
            center={true}
            style={{ marginBottom: "5px" }}
          />

          {this.state.districtSidebarTab === "available" && (
            <>
              <div className={"side-menu-title my-0"}>
                <FilterDisplay
                  filters={this.state.districtFilters}
                  openFilterModal={() => {
                    this.setState({ filterModalOpen: true });
                  }}
                  handleFilterDeletion={(filterType, val, filters) => {
                    this.setState(
                      {
                        districtFilters: handleFilterDeletion(
                          filterType,
                          val,
                          filters
                        ),
                      },
                      this.handleDistrictsOnFilter
                    );
                  }}
                  handleSearchChange={(val) => {
                    debouncedDistrictSearch(val);
                  }}
                  handleSortUpdate={(val) => {
                    this.setState({
                      districtFilters: {
                        ...this.state.districtFilters,
                        sortBy: val,
                      },
                    });
                  }}
                  handleSortDirectionChange={() =>
                    this.setState({
                      districtFilters: {
                        ...this.state.districtFilters,
                        sortDsc: !this.state.districtFilters.sortDsc,
                      },
                    })
                  }
                  value={districtValue}
                />
              </div>
              {visibleDistricts.map((d) => (
                <DistrictTurfListItem
                  isDistrict
                  data={d}
                  focused={false}
                  color={
                    this.state.selectedDistricts.filter((_d) => _d.id === d.id)
                      .length
                      ? "#fdbf6f"
                      : null
                  }
                  key={d.id}
                  onMouseEnter={() =>
                    this.setState({
                      hoveredFeatures: [d.id],
                      hoveredSource: "district-points",
                    })
                  }
                  onMouseLeave={() =>
                    this.setState({ hoveredFeatures: [], hoveredSource: null })
                  }
                  onClick={() => {
                    const deconstructedDistrict = {
                      ...d,
                      source: "district-points",
                    };
                    this.state.selectedDistricts.filter((_d) => _d.id === d.id)
                      .length
                      ? this.handleSelectedDistrictRemoval(
                          deconstructedDistrict
                        )
                      : this.handleAvailDistrictDoubleClick(
                          deconstructedDistrict
                        );
                  }}
                />
              ))}
            </>
          )}

          {this.state.districtSidebarTab === "selected" && (
            <>
              {/*case of nothing selected*/}
              {!this.state.selectedDistricts.length && (
                <div className="side-menu-list-obj district">
                  <div
                    className="list-obj-inner-wrapper"
                    style={{ borderLeftColor: "#8a8a8a" }}
                  >
                    <div className="obj-title" style={{ color: "#8a8a8a" }}>
                      Nothing Selected
                    </div>
                  </div>
                </div>
              )}
              {/*case of something selected*/}
              {this.state.selectedDistricts.map((d) => (
                <DistrictTurfListItem
                  isDistrict
                  data={d}
                  focused={false}
                  key={d.id}
                  color={"#fdbf6f"}
                  hoverColor={"#c60115"}
                  onMouseEnter={() => {}}
                  onMouseLeave={() => {}}
                  onClick={() => null}
                  onRemove={() => this.handleSelectedDistrictRemoval(d)}
                />
              ))}
            </>
          )}
        </div>
      </>
    );
  }

  _renderTurfCreateSideBar() {
    let total_doors = this.state.selectedDistricts.reduce(
      (r, d) => +d.household_count + r,
      0
    );
    let doors_attempted = this.state.districtFeatures.reduce(
      (r, d) => (d.attempted ? r + 1 : r),
      0
    );
    let walkable_cut = 0;
    let unwalkable_cut = 0;

    this.state.turfs.forEach((turf) => {
      if (turf.is_walkable) {
        walkable_cut += turf.targets.length;
      } else {
        unwalkable_cut += turf.targets.length;
      }
    });

    let cut_ratio = (walkable_cut + unwalkable_cut) / total_doors;
    let attempt_ratio = doors_attempted / total_doors;

    let turfValue =
      this.state.turfFilters.keywordPersist !== ""
        ? { value: this.state.turfFilters.keyword }
        : { test: 1 };

    const debouncedTurfSearch = debounce((query) => {
      const stateChanges = handleSearchChange(query);
      this.setState(
        {
          ...stateChanges[0],
          turfFilters: {
            ...this.state.turfFilters,
            keyword: stateChanges[1],
          },
        },
        this.handleTurfsOnFilter
      );
    }, 300);

    return (
      <>
        <div className="side-menu-title" style={{ marginBottom: "1em" }}>
          <h3
            className="primary-text"
            style={{ textAlign: "center", marginBottom: ".2em" }}
          >
            Build Turfs
          </h3>

          <p
            style={{
              textAlign: "center",
              marginTop: ".5em",
              marginBottom: ".5em",
            }}
            className={"primary-text"}
          >
            Cutting{" "}
            {this.state.selectedDistricts.map((d, i, a) => (
              <span key={d.name}>
                {d.name}
                {i !== a.length - 1 ? ", " : ""}
              </span>
            ))}
          </p>

          <div className={"side-menu-info-box"}>
            <div className="obj-data">
              <span>
                <b>{total_doors}</b> Doors, <b>{this.state.turfs.length}</b>{" "}
                Turfs
              </span>
            </div>
            <div className="obj-data">
              <span>
                <b
                  className={cut_ratio > 0.98 ? "success-text" : "danger-text"}
                >
                  {Math.round(cut_ratio * 100)}% cut
                </b>{" "}
                -- {walkable_cut} walkable,{" "}
                <span className={unwalkable_cut > 0 ? "danger-text" : ""}>
                  {unwalkable_cut} not
                </span>
              </span>
            </div>
            <div className="obj-data">
              <span>
                <b className={"success-text"}>{doors_attempted} attempted</b> (
                {Math.round(attempt_ratio * 100)}%)
              </span>
            </div>
          </div>

          {!!this.state.turfs.length && (
            <>
              <p
                style={{
                  textAlign: "center",
                  marginTop: "1em",
                  marginBottom: ".3em",
                }}
              >
                {this.state.editingTurf ? (
                  "Editing " + this.state.editingTurf.name
                ) : (
                  <span>
                    Double Click a Turf to Edit or
                    <a
                      onClick={() =>
                        this.setState({ releaseDoorsModalOpen: true })
                      }
                      style={{ fontSize: ".8em" }}
                    >
                      {" "}
                      Release Unknocked Doors
                    </a>
                  </span>
                )}
              </p>
              {/*<p className="primary-milligram-text"*/}
              {/*     style={{cursor: "pointer", textAlign: "center", marginTop: "0", fontSize: '.7em'}}*/}
              {/*     onClick={this.handleReleaseUnknockedDoorsRequest}>*/}
              {/*    Release unknocked doors*/}
              {/*</p>*/}
            </>
          )}

          {!!this.state.lassoedFeatures.length && !this.state.editingTurf && (
            <BasicButton
              disabled={this.state.addRouteValue === ""}
              on_click={this.handleCreateTurfRequest}
              aria_label="Create Turf"
              label="Create Turf"
              className="mapButton"
            />
          )}

          {!!this.state.lassoedFeatures.length && this.state.editingTurf && (
            <>
              <BasicButton
                disabled={this.state.addRouteValue === ""}
                on_click={() => this.setState({ turfEditModalOpen: true })}
                aria_label="Edit Turf Options"
                label="Edit Turf Options"
                className="mapButton primary"
              />
              <BasicButton
                disabled={this.state.addRouteValue === ""}
                on_click={this.cancelTurfUpdate}
                aria_label="Cancel"
                label="Cancel"
                className="mapButton danger"
              />
              <BasicButton
                disabled={this.state.addRouteValue === ""}
                on_click={this.handleUpdateTurfRequest}
                aria_label="Update Turf"
                label="Update Turf"
                className="mapButton success"
              />
            </>
          )}
        </div>

        {!!this.state.lassoedFeatures.length && (
          <div className="agg-metrics">
            <div className="agg-metric">
              <span className="metricKey">Households Selected</span>
              <span className="metricValue" style={{ fontWeight: "bold" }}>
                {this.state.lassoedFeatures.length}
              </span>
            </div>
            <div className="agg-metric">
              <span className="metricKey">Targets Selected</span>
              <span className="metricValue" style={{ fontWeight: "bold" }}>
                {this.state.lassoedFeatures.reduce(
                  (r, d) => r + (d.target_count || 0),
                  0
                )}
              </span>
            </div>
          </div>
        )}

        <div className="side-menu-body">
          {!this.state.editingTurf && !this.state.lassoedFeatures.length && (
            <div className="side-menu-list-obj district">
              <div
                className="list-obj-inner-wrapper"
                style={{ borderLeftColor: "#8a8a8a" }}
              >
                <div
                  className="obj-title"
                  style={{
                    color: "#8a8a8a",
                    fontSize: "16px",
                    lineHeight: "1.1em",
                  }}
                >
                  Select some households to create a turf.
                </div>
              </div>
            </div>
          )}
          <div className="side-menu-list-obj">
            <FilterDisplay
              openFilterModal={() => {
                this.setState({ filterModalOpen: true });
              }}
              filters={this.state.turfFilters}
              handleSearchChange={(val) => {
                debouncedTurfSearch(val);
              }}
              handleSortUpdate={(val) => {
                this.setState({
                  turfFilters: {
                    ...this.state.turfFilters,
                    sortBy: val,
                  },
                });
              }}
              handleSortDirectionChange={() =>
                this.setState({
                  turfFilters: {
                    ...this.state.turfFilters,
                    sortDsc: !this.state.turfFilters.sortDsc,
                  },
                })
              }
              handleFilterDeletion={(filterType, val, filters) => {
                this.setState(
                  {
                    turfFilters: handleFilterDeletion(filterType, val, filters),
                  },
                  this.handleTurfsOnFilter
                );
              }}
              value={turfValue}
            />
          </div>

          <div className="side-menu-list-divider">
            <h6 className={"primary-text"}>Walkable</h6>
          </div>

          {filterAndSortItems(this.state.turfs, this.state.turfFilters)
            .filter((d) => d.is_walkable !== false)
            .map((d, i) => (
              <DistrictTurfListItem
                data={d}
                focused={false}
                key={d.id}
                color={this.getTurfColor(d, d.id)}
                onMouseEnter={() => this.handleTurfItemHover(d, i, true)}
                onMouseLeave={() => this.handleTurfItemHover(d, i, false)}
                onClick={() => null}
                onRemove={() => this.deleteTurf(d.id)}
                onDoubleClick={() => this.makeTurfEditable(d)}
              />
            ))}

          <div className="side-menu-list-divider">
            <h6 className={"primary-text"}>Not Walkable</h6>
          </div>

          {filterAndSortItems(this.state.turfs, this.state.turfFilters)
            .filter((d) => d.is_walkable === false)
            .map((d, i) => (
              <DistrictTurfListItem
                data={d}
                focused={false}
                key={d.id}
                color={this.getTurfColor(d, d.id)}
                onMouseEnter={() => this.handleTurfItemHover(d, i, true)}
                onMouseLeave={() => this.handleTurfItemHover(d, i, false)}
                onClick={() => null}
                onRemove={() => this.deleteTurf(d.id)}
                onDoubleClick={() => this.makeTurfEditable(d)}
              />
            ))}
        </div>
      </>
    );
  }

  returnToDistrictMode = () => {
    this.setState(
      {
        mapMode: "district",
        turfFeatures: [],
        cutTurfPolys: [],
        selectedPointsPoly: null,
      },
      this.handleMountOrDistrictTypeChange
    );
    this.handleDeselectAllDistricts();
    this.handleDeselectAllDoors();
  };

  isLoading = () => {
    return this.state.isLoading;
  };

  setError = (msg) => {
    msg = msg || "Server error.";
    this.setState(
      {
        errMsg: msg,
        error: true,
        isLoading: false,
      },
      () => {
        setTimeout(() => this.setState({ error: false }), 3000);
      }
    );
  };

  setLoading = (bool = true) => {
    this.setState({ isLoading: bool });
  };

  setSuccess = (msg) => {
    msg = msg || "Success";
    this.setState(
      {
        successMsg: msg,
        success: true,
        isLoading: false,
      },
      () => {
        setTimeout(() => this.setState({ success: false }), 3000);
      }
    );
  };

  encodePoints = (points, source) => {
    return {
      type: "FeatureCollection",
      features: points.map((point) => {
        let turfColor;
        if (source === "turf-points") {
          const pointTurf = this.state.turfs.find(
            (t) => t.targets.indexOf(point.id) > -1
          );
          if (pointTurf) {
            turfColor =
              pointTurf.color || this.getTurfColor(pointTurf, pointTurf.id);
          }
        }

        return {
          type: "Feature",
          source: source,
          id: point.id,
          geometry: {
            type: "Point",
            coordinates: [
              +point.lon || +point.longitude || 0,
              +point.lat || +point.longitude || 0,
            ],
          },
          properties: {
            label: point.name,
            disabled: !!point.suppressed || !!point.attempted,
            data: point,
            count: point.household_count || point.cluster_count,
            interpolatePercentage:
              (point.walkable_cut || 0 + point.unwalkable_cut || 0) /
              point.household_count,
            source: source,
            groupColor: turfColor || "#9b4dca", // default to wox purple if not cut
          },
        };
      }),
    };
  };

  render() {
    return (
      <div id="turfcutter">
        <FloatHeader link="/doorcanvass" />
        <div style={{ width: "100vw", height: "100vh" }}>
            <BaseMap
              defaultViewState={US_DEFAULT_MAP_VIEW}
              // we only want the ref, and do not care about the bounds or visible features
              handleViewChange={(viewState, ref) => {
                this.setState({ viewState });
                if (ref) {
                  this.mapRef = ref;
                }
              }}
              hoveredFeatures={this.state.hoveredFeatures}
              hoveredSource={this.state.hoveredSource}
              sources={[
                {
                  id: "district-points",
                  type: "geojson",
                  data: this.encodePoints(
                    filterAndSortItems(
                      this.state.districtFeatures,
                      this.state.districtFilters
                    ),
                    "district-points"
                  ),
                  style: relativeSizePointStyle,
                  internalCount: true,
                  interpolateColor: true,
                  isInteractive: true,
                  hidden: this.state.mapMode === "turf",

                  selectedFeatures: this.state.selectedDistricts,
                  onHover: (features) => {
                    this.onMarkerHover(features[0].properties.data);
                  },

                  onMouseLeave: () => {},
                  onClick: (feature) => {
                    const deconstructedFeature = {
                      ...feature.properties.data,
                      id: feature.id,
                      source: feature.source,
                    };
                    this.state.selectedDistricts.find(
                      (_d) => _d.id === feature.id
                    )
                      ? this.handleSelectedDistrictRemoval(deconstructedFeature)
                      : this.handleAvailDistrictDoubleClick(
                          deconstructedFeature
                        );
                  },
                  popupComponentGenerator: (feature) => {
                    const deconstructedFeature = feature.properties.data;
                    if (!deconstructedFeature) return <></>;

                    return (
                      <DistrictTurfListItem
                        data={deconstructedFeature}
                        focused={false}
                        key={feature.id}
                        color={this.getTurfColor(
                          deconstructedFeature,
                          feature.id
                        )}
                        isDistrict
                      />
                    );
                  },
                },
                {
                  id: "convex-hulls",
                  type: "geojson",
                  data: {
                    type: "FeatureCollection",
                    features: [
                      ...this.state.cutTurfPolys,
                      this.state.selectedPointsPoly,
                    ].filter((n) => n),
                  },
                  style: defaultPolyStyle,
                  outline: true,
                  isInteractive: true,
                  onDblClick: (feature) => {
                    if (!feature.id) return;
                    this.makeTurfEditable(feature.properties.data);
                  },
                  popupComponentGenerator: (feature) => {
                    if (!feature.id) return;
                    return (
                      <DistrictTurfListItem
                        data={feature.properties.data}
                        focused={false}
                        key={feature.id}
                        color={this.getTurfColor(
                          feature.properties.data,
                          feature.id
                        )}
                        onRemove={() => this.deleteTurf(feature.id)}
                        onDoubleClick={() =>
                          this.makeTurfEditable(feature.properties.data)
                        }
                      />
                    );
                  },
                },

                {
                  id: "turf-points",
                  type: "geojson",
                  data: this.encodePoints(
                    this.state.turfFeatures,
                    "turf-points"
                  ),
                  style: groupedRelativePointStyle,
                  isInteractive: true,
                  selectedFeatures: this.state.lassoedFeatures,
                  onHover: (features) => {
                    return null;
                  },
                  onClick: (feature) => {
                    const deconstructedFeature = {
                      ...feature.properties.data,
                      id: feature.id,
                      source: feature.source,
                    };

                    if (
                      this.state.turfs.find((turf) => {
                        return turf.targets.indexOf(feature.id) !== -1;
                      })
                    ) {
                      return;
                    }

                    this.state.lassoedFeatures.find((f) => f.id === feature.id)
                      ? this.setState({
                          lassoedFeatures: this.state.lassoedFeatures.filter(
                            (f) => f.id !== feature.id
                          ),
                        })
                      : this.setState({
                          lassoedFeatures: [
                            ...this.state.lassoedFeatures,
                            deconstructedFeature,
                          ],
                        });
                    this.props.setInfoFeedMessage({
                      id: "count_selected_doors",
                      msg:
                        this.state.lassoedFeatures.length +
                        " Total Doors Selected",
                      timeoutLength: this.state.lassoedFeatures.length
                        ? 9999999999
                        : 3000,
                      onClick: this.state.lassoedFeatures.length
                        ? this.handleDeselectAllDoors
                        : null,
                      onClickName: "Deselect All",
                      cantClose: true,
                    });

                    let encodedPoints = this.encodePoints(
                      this.state.lassoedFeatures
                    );

                    let poly = null;

                    if (encodedPoints.features.length > 2) {
                      poly = convex(encodedPoints);
                    }

                    if (poly) {
                      poly = transformScale(poly, 1.1);
                    }

                    this.setState({
                      selectedPointsPoly: poly,
                    });
                  },
                  popupComponentGenerator: (feature) => {
                    const deconstructedFeature = feature.properties.data;
                    return (
                      <div id={"hover-info-box"} className={"active"}>
                        <div className={"hover-info-box-line"}>
                          <b>
                            {deconstructedFeature.street_address_1}{" "}
                            {deconstructedFeature.street_address_2}
                          </b>
                        </div>
                        <div className={"hover-info-box-line"}>
                          {deconstructedFeature.target_count} target
                          {deconstructedFeature.target_count > 1 && "s"}
                        </div>
                        <div className={"hover-info-box-line"}>
                          {deconstructedFeature.cluster_count} household
                          {deconstructedFeature.cluster_count > 1 && "s"}
                        </div>
                      </div>
                    );
                  },
                },
              ]}
            />
        </div>

        <div
          className={`map-side-menu ${this.state.sideBarClosed && "closed"}`}
        >
          <div className="side-menu-wrapper" id="side-menu-scroll-wrapper">
            {this.state.mapMode === "district" &&
              this._renderDistrictSelectSideBar()}
            {this.state.mapMode === "turf" && (
              <>
                <div className="side-menu-top-icons" style={{ height: "1em" }}>
                  <span
                    className="top-icon fa fa-level-up-alt"
                    onClick={this.returnToDistrictMode}
                  />
                </div>

                {this._renderTurfCreateSideBar()}
              </>
            )}
          </div>
          <div
            className={`side-menu-select-wrapper ${
              this.state.sideBarClosed && "closed"
            }`}
          >
            <div
              className="side-menu-option toggle"
              style={{ marginTop: "12vh" }}
              onClick={() =>
                this.setState({ sideBarClosed: !this.state.sideBarClosed })
              }
            >
              <i
                className={`fas ${
                  this.state.sideBarClosed ? "fa-arrow-left" : "fa-arrow-right"
                }`}
              />
            </div>
            {this.isLoading() && (
              <div className={`side-menu-option loading`}>
                <i className="fas fa-asterisk" />
              </div>
            )}
          </div>
        </div>

        <InfoTileFeed
          showInfoFeed={true}
          messageStyle={{
            lineHeight: "1.5m",
            color: "#1679c7", // primary text color
            fontWeight: "bold",
            alignItems: "center",
            justifyContent: "center",
            fontSize: ".8em",
            padding: ".5em",
            zIndex: "99",
          }}
        />
        <FeedbackTile
          text={
            <div>
              <i
                className="fas fa-exclamation-triangle"
                style={{ marginRight: "15px" }}
              />
              {this.state.errMsg}
            </div>
          }
          visible={this.state.error}
          classNames="danger clear-sidebar-feedback-tile"
        />

        <FeedbackTile
          text={
            <div>
              <i
                className="fas fa-check-circle"
                style={{ marginRight: "15px" }}
              />
              {this.state.successMsg}
            </div>
          }
          visible={this.state.success}
          classNames="success clear-sidebar-feedback-tile"
        />

        {/* create turf modal */}
        <BaseModal
          open={this.state.turfEditModalOpen}
          onClose={this.onCloseTurfEditModal}
          center
        >
          <BaseForm
            inputs={[
              {
                ...formFields.genericName,
                validator: (val) => val && val.length > 1,
                errMsg: "You must give this at least a two character name.",
                value: this.state.editingTurf
                  ? this.state.editingTurf.name
                  : null,
              },
              {
                type: "text",
                title: "Notes",
                dataKey: "notes",
                placeholder: "",
                value: this.state.editingTurf
                  ? this.state.editingTurf.notes
                  : null,
              },
              {
                type: "select",
                title: "What kind of turf is this?",
                dataKey: "code",
                value: this.state.editingTurf ? this.state.editingTurf.code : 1,
                options: [
                  ...this.props.turfCodes.map((d) => ({
                    value: d.id,
                    display: d.name,
                  })),
                ],
              },
              {
                type: "text",
                title: "Intended Walk Date (M/D)",
                dataKey: "intended_walk_date",
                placeholder: "",
                value:
                  this.state.editingTurf &&
                  this.state.editingTurf.intended_walk_date
                    ? new Moment(
                        this.state.editingTurf.intended_walk_date,
                        "YYYY-MM-DD"
                      ).format("M/D")
                    : null,
                validator: (val) => {
                  if (!val || val === "") return true;
                  const isGoodDateRegexp =
                    /^(?:(0?[1-9]|1[012])[/](0?[1-9]|[12][0-9]|3[01]))$/;
                  return isGoodDateRegexp.test(val);
                },
                errorMsg: "Date must be in M/D format",
              },
            ]}
            onCancel={this.onCloseTurfEditModal}
            disableSubmit={this.state.isLoading}
            onSubmit={(inputs) => {
              // convert date input

              if (
                inputs.intended_walk_date &&
                inputs.intended_walk_date.length
              ) {
                inputs.intended_walk_date = new Moment(
                  inputs.intended_walk_date,
                  "M/D"
                ).format("YYYY-MM-DD");
              }
              if (!this.state.editingTurf) {
                this.createTurf(inputs).then((turf) => {
                  this.handleDeselectAllDoors();
                  this.onCloseTurfEditModal();
                  this.props.setTurfNoteModalTurf({ ...turf, turfnotes: [] });
                });
              } else {
                this.setState(
                  { editingTurf: { ...this.state.editingTurf, ...inputs } },
                  () =>
                    this.handleUpdateTurfRequest().then(
                      this.onCloseTurfEditModal
                    )
                );
              }
            }}
          />
        </BaseModal>

        {/* create release doors confirm modal */}
        <BaseModal
          open={this.state.releaseDoorsModalOpen}
          onClose={this.onCloseReleaseDoorsModal}
          center
        >
          <div className={"modalWrapper"}>
            <h5 style={{ marginBottom: "1em" }}>
              Are you sure you would like to release unknocked doors? This will
              affect{" "}
              <span className={"primary-milligram-text"}>
                {this.state.turfs.reduce(
                  (r, d) =>
                    get(d, "agg_data.households_attempted", 0) > 0 ? r + 1 : r,
                  0
                )}
              </span>{" "}
              {/* this is the number of walked turfs */}
              walked turfs and cannot be undone.
            </h5>
            <div className={"button-wrapper"}>
              <button
                className={"button"}
                onClick={() => {
                  this.releaseUnknockedDoors();
                  this.onCloseReleaseDoorsModal();
                }}
              >
                Yes
              </button>
              <button
                className={"button button-outline"}
                onClick={this.onCloseReleaseDoorsModal}
              >
                Cancel
              </button>
            </div>
          </div>
        </BaseModal>

        <TurfNoteModal
          showCloseIcon
          center
          handleNoteCreateOrDestroy={this.handleTurfNoteCreateOrDestroy}
        />

        <DistrictNoteModal
          showCloseIcon
          center
          handleNoteCreateOrDestroy={this.handleDistrictNoteCreateOrDestroy}
        />
        {this.state.filterModalOpen &&
          (this.state.mapMode === "district" ? (
            <DistrictFilterModal
              showCloseIcon
              center
              handleOnClose={this.handleDistrictFilterModalClose}
              open={true}
              filters={this.state.districtFilters}
            />
          ) : (
            <TurfFilterModal
              showCloseIcon
              center
              handleOnClose={this.handleTurfFilterModalClose}
              open={true}
              filters={this.state.turfFilters}
            />
          ))}
        <FeedbackTile
          text={
            <div>
              <i
                className="fas fa-exclamation-triangle"
                style={{ marginRight: "15px" }}
              />
              {this.props.notesError || "There was a server error."}
            </div>
          }
          visible={this.props.notesError}
          classNames="danger"
        />
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  focusedCampaign: state.session.focusedCampaign,
  turfCodes: state.turfCodes.data,
  doorCanvassPasses: state.doorCanvassPasses.data,
  notesError: state.siteNotes.error,
});

// TODO: is this necessary on this page?
const mapDispatchToProps = (dispatch) => ({
  setInfoFeedMessage: (msg) => dispatch(setInfoFeedMessage(msg)),
  removeInfoFeedMessage: (msg) => dispatch(removeInfoFeedMessage(msg)),
  setSelectedOffice: (id) =>
    dispatch(setDashboardParams({ selectedOffice: id })),
  setDistrictNoteModalDistricts: (district) =>
    dispatch(setSessionVar("districtNoteModalDistricts", district)),
  setTurfNoteModalTurf: (turf) =>
    dispatch(setSessionVar("turfNoteModalTurf", turf)),
});

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(TurfCutter));
